/** packages/shared-components/src/hooks/useKeyboardConnection.ts */

import { useState, useCallback, useEffect } from "react";
import type { KeyboardSDK, DeviceInfo } from "../types/sdk";

export type ConnectionStatus =
  | "disconnected"
  | "connecting"
  | "ready"
  | "error";

export interface UseKeyboardConnectionResult {
  status: ConnectionStatus;
  device: DeviceInfo | null;
  errorMsg: string;
  connect: () => Promise<void>;
  reset: () => void;
}

export interface UseKeyboardConnectionOptions {
  sdkApi?: KeyboardSDK;
  /** 自动连接（SDK 就绪后立即尝试连接） */
  autoConnect?: boolean;
  /** 是否需要用户交互（显示设备选择弹窗） */
  requireUserInteraction?: boolean;
  onConnected?: (device: DeviceInfo) => void;
  onError?: (error: Error) => void;
}

// ==================== WebHID 最小类型定义 ====================
// interface HIDDevice {
//   vendorId: number;
//   productId: number;
//   productName: string;
// }

// interface HIDDeviceRequestOptions {
//   filters: Array<{
//     vendorId?: number;
//     productId?: number;
//     usagePage?: number;
//     usage?: number;
//   }>;
// }

// interface HID {
//   requestDevice(options?: HIDDeviceRequestOptions): Promise<HIDDevice[]>;
// }

// 类型守卫
// function supportsHID(nav: Navigator): nav is Navigator & { hid: HID } {
//   return "hid" in nav && nav.hid !== undefined;
// }

// ==================== Hook 实现 ====================
export function useKeyboardConnection(
  options: UseKeyboardConnectionOptions = {}
): UseKeyboardConnectionResult {
  const {
    sdkApi,
    autoConnect = false,
    requireUserInteraction = false,
    onConnected,
    onError,
  } = options;

  const [status] = useState<ConnectionStatus>("ready");
  const [device] = useState<DeviceInfo | null>(null);
  const [errorMsg] = useState<string>("");

  const connect = useCallback(async () => {
    // setStatus("connecting");
    // setErrorMsg("");
    // try {
    //   // 1. 检查浏览器支持（仅在需要用户交互时检查）
    //   if (requireUserInteraction && !supportsHID(navigator)) {
    //     throw new Error("浏览器不支持 WebHID API");
    //   }
    //   // 2. 检查 SDK API
    //   if (!sdkApi?.sdkKeyboardBasicApi) {
    //     throw new Error("SDK API 不可用");
    //   }
    //   // // 3. 请求 WebHID 权限（可选）
    //   // if (requireUserInteraction) {
    //   //     const hidDevices = await navigator.hid.requestDevice({ filters: [] })
    //   //     if (!hidDevices || hidDevices.length === 0) {
    //   //         throw new Error('未选择设备')
    //   //     }
    //   // }
    //   // 4. 获取设备列表
    //   const devicesResponse = await sdkApi.sdkKeyboardBasicApi.getDevices();
    //   if (
    //     devicesResponse.code !== 200 ||
    //     !devicesResponse.data ||
    //     devicesResponse.data.length === 0
    //   ) {
    //     throw new Error(devicesResponse.message || "未检测到设备");
    //   }
    //   const preferredIdentifier =
    //     localStorage.getItem("currentKeyboardIdentifier") ||
    //     (() => {
    //       try {
    //         const raw = localStorage.getItem("equipmentData");
    //         if (!raw) return "";
    //         const parsed = JSON.parse(raw);
    //         return parsed?.identifier ? String(parsed.identifier) : "";
    //       } catch {
    //         return "";
    //       }
    //     })();
    //   const preferredProductName =
    //     localStorage.getItem("currentDeviceName") ||
    //     (() => {
    //       try {
    //         const raw = localStorage.getItem("equipmentData");
    //         if (!raw) return "";
    //         const parsed = JSON.parse(raw);
    //         return parsed?.productName ? String(parsed.productName) : "";
    //       } catch {
    //         return "";
    //       }
    //     })();
    //   const targetDevice =
    //     (preferredIdentifier
    //       ? devicesResponse.data.find(
    //           (d) => String(d.id) === String(preferredIdentifier)
    //         )
    //       : undefined) ||
    //     (preferredProductName
    //       ? devicesResponse.data.find(
    //           (d) => String(d.productName) === String(preferredProductName)
    //         )
    //       : undefined) ||
    //     devicesResponse.data[0];
    //   const initResponse = await sdkApi.sdkKeyboardBasicApi.init(targetDevice);
    //   if (initResponse.code !== 200) {
    //     throw new Error(initResponse.message || "初始化失败");
    //   }
    //   // 6. 连接成功
    //   setDevice(targetDevice);
    //   setStatus("ready");
    //   onConnected?.(targetDevice);
    // } catch (error: any) {
    //   const message = error.message || "连接失败，请重试";
    //   setStatus("error");
    //   setErrorMsg(message);
    //   onError?.(error);
    //   console.error("键盘连接失败:", error);
    // }
  }, [sdkApi, requireUserInteraction, onConnected, onError]);

  const reset = useCallback(() => {
    // setStatus("disconnected");
    // setDevice(null);
    // setErrorMsg("");
  }, []);

  // 自动连接
  useEffect(() => {
    // if (
    //   autoConnect &&
    //   sdkApi?.sdkKeyboardBasicApi &&
    //   status === "disconnected"
    // ) {
    //   connect();
    // }
  }, [autoConnect, sdkApi?.sdkKeyboardBasicApi, status, connect]);

  return {
    status,
    device,
    errorMsg,
    connect,
    reset,
  };
}
